'use client';

import Image, { ImageProps } from 'next/image';
import { FC, memo, useEffect, useState } from 'react';

import cloudfrontLoader from './loader';
import { blurImagePlaceholder } from '@/theme/placeholders';

export const ImageComponent = memo(({ src, ...props }: ImageProps) => {
  const [imgSrc, setImgSrc] = useState(src || blurImagePlaceholder);

  useEffect(() => {
    if (src) {
      setImgSrc(src);
    }
  }, [src]);

  const handleError = () => {
    setImgSrc(blurImagePlaceholder);
  };

  return (
    <Image
      src={imgSrc}
      {...props}
      onError={handleError}
      loader={cloudfrontLoader}
    />
  );
});
